import "./GlobalConfig.scss";
import { getTokenHeader } from "../../../helpers/commonHelper";
import axios from "axios";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
export default {
  name: "GlobalConfig",
  data: () => ({}),
  async mounted() {
    if (!this.isAdmin) return;
    await this.$store.dispatch("getGlobalEoConfig");
  },
  methods: {
    async createGlobalConfig() {
      try {
        if (!this.isAdmin) return;
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.auth_api_client_url}globalConfig`,
          { dsgvoLink: this.dsgvoLink, impressumLink: this.impressumLink },
          { headers }
        );
        this.globalConfig = response.data?.data;
        await this.$store.dispatch("createSuccess", "Erfolgreich erstellt!");
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e);
      }
    },
    async updateGlobalConfig() {
      try {
        if (!this.isAdmin) return;
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.auth_api_client_url}globalConfig/${this.globalConfig._id}`,
          { dsgvoLink: this.dsgvoLink, impressumLink: this.impressumLink },
          { headers }
        );
        this.globalConfig = response.data?.data;
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e);
      }
    }
  },
  computed: {
    globalConfig() {
      return this.$store.state.globalEoConfig;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    dsgvoLink: {
      get() {
        return this.globalConfig?.dsgvoLink || "";
      },
      set(val) {
        this.globalConfig.dsgvoLink = val;
      }
    },
    impressumLink: {
      get() {
        return this.globalConfig?.impressumLink || "";
      },
      set(val) {
        this.globalConfig.impressumLink = val;
      }
    }
  }
};
